import { useEffect } from 'react';
import { useUser } from '../UserContext';
import { setServerToken } from '../utils/fetch';

/**
 * Hook that connects the UserContext token to the fetch utility
 * This should be used in a high-level component that wraps your app
 * or in components that make API calls
 */
export const useFetchToken = (token: string | null) => {
  useEffect(() => {
    console.log("Token changed:", token);
    // Update the global token store whenever the token changes
    setServerToken(token);
  }, [token]);

  return null;
}; 